// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n3F9","questions":"styles_questions__tVm7a","footer":"styles_footer__mWOes"};